"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSaveCheckMeterConfigMutation = exports.useSaveProductionBulkConfigMutation = exports.useLazyFetchCheckMeterNameQuery = exports.useLazyFetchAvailableCheckMetersQuery = exports.useLazyFetchCheckableMetersQuery = exports.useFetchCheckMeterConfigQuery = exports.useCreateMissingMetersMutation = exports.useFetchMissingMetersQuery = exports.useFetchProductionBulkConfigQuery = exports.meterPremiseConfigApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.meterPremiseConfigApi = (0, react_1.createApi)({
    reducerPath: "meterPremiseConfigApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["productionBulkConfig", "checkMeterConfig", "missingMeters"],
    endpoints: function (builder) { return ({
        fetchProductionBulkConfig: builder.query({
            query: function (_a) {
                var clientId = _a.clientId, buildingId = _a.buildingId;
                return ({
                    url: "/v1/meter-premise-config/production-bulk",
                    method: "GET",
                    params: { clientId: clientId, buildingId: buildingId },
                });
            },
            providesTags: ["productionBulkConfig"],
        }),
        fetchCheckMeterConfig: builder.query({
            query: function (_a) {
                var clientId = _a.clientId, buildingId = _a.buildingId;
                return ({
                    url: "/v1/meter-premise-config/check-meters",
                    method: "GET",
                    params: { clientId: clientId, buildingId: buildingId },
                });
            },
            providesTags: ["checkMeterConfig"],
        }),
        /*
         * Searched on the server, on serial OR premise/area name, because Erik asked for both and a
         * building can hold hundreds of meters. Lazy, so it costs nothing until a drop-down opens.
         */
        fetchCheckableMeters: builder.query({
            query: function (_a) {
                var clientId = _a.clientId, buildingId = _a.buildingId, search = _a.search, limit = _a.limit;
                return ({
                    url: "/v1/meter-premise-config/checkable-meters",
                    method: "GET",
                    params: __assign(__assign({ clientId: clientId, buildingId: buildingId }, (search ? { search: search } : {})), (limit ? { limit: limit } : {})),
                });
            },
        }),
        /** Compose and uniqueness-check a name before the user commits to it. */
        fetchCheckMeterName: builder.query({
            query: function (_a) {
                var clientId = _a.clientId, buildingId = _a.buildingId, description = _a.description, premiseId = _a.premiseId;
                return ({
                    url: "/v1/meter-premise-config/check-meter-name",
                    method: "GET",
                    // premiseId lets the server exclude this premise's own group from the clash check.
                    params: __assign({ clientId: clientId, buildingId: buildingId, description: description }, (premiseId != null ? { premiseId: premiseId } : {})),
                });
            },
        }),
        fetchAvailableCheckMeters: builder.query({
            query: function (_a) {
                var clientId = _a.clientId, buildingId = _a.buildingId, search = _a.search, limit = _a.limit;
                return ({
                    url: "/v1/meter-premise-config/available-check-meters",
                    method: "GET",
                    params: __assign(__assign({ clientId: clientId, buildingId: buildingId }, (search ? { search: search } : {})), (limit ? { limit: limit } : {})),
                });
            },
        }),
        fetchMissingMeters: builder.query({
            query: function (_a) {
                var clientId = _a.clientId, buildingId = _a.buildingId;
                return ({
                    url: "/v1/meter-premise-config/missing-meters",
                    method: "GET",
                    params: { clientId: clientId, buildingId: buildingId },
                });
            },
            providesTags: ["missingMeters"],
        }),
        createMissingMeters: builder.mutation({
            query: function (body) { return ({ url: "/v1/meter-premise-config/create-missing-meters", method: "POST", body: body }); },
            invalidatesTags: ["missingMeters", "productionBulkConfig", "checkMeterConfig"],
        }),
        saveProductionBulkConfig: builder.mutation({
            query: function (body) { return ({ url: "/v1/meter-premise-config/production-bulk/save", method: "POST", body: body }); },
            invalidatesTags: ["productionBulkConfig"],
        }),
        saveCheckMeterConfig: builder.mutation({
            query: function (body) { return ({ url: "/v1/meter-premise-config/check-meters/save", method: "POST", body: body }); },
            invalidatesTags: ["checkMeterConfig"],
        }),
    }); },
});
exports.useFetchProductionBulkConfigQuery = exports.meterPremiseConfigApi.useFetchProductionBulkConfigQuery, exports.useFetchMissingMetersQuery = exports.meterPremiseConfigApi.useFetchMissingMetersQuery, exports.useCreateMissingMetersMutation = exports.meterPremiseConfigApi.useCreateMissingMetersMutation, exports.useFetchCheckMeterConfigQuery = exports.meterPremiseConfigApi.useFetchCheckMeterConfigQuery, exports.useLazyFetchCheckableMetersQuery = exports.meterPremiseConfigApi.useLazyFetchCheckableMetersQuery, exports.useLazyFetchAvailableCheckMetersQuery = exports.meterPremiseConfigApi.useLazyFetchAvailableCheckMetersQuery, exports.useLazyFetchCheckMeterNameQuery = exports.meterPremiseConfigApi.useLazyFetchCheckMeterNameQuery, exports.useSaveProductionBulkConfigMutation = exports.meterPremiseConfigApi.useSaveProductionBulkConfigMutation, exports.useSaveCheckMeterConfigMutation = exports.meterPremiseConfigApi.useSaveCheckMeterConfigMutation;
